import { forwardRef, Ref, SVGAttributes } from 'react';
import { Icon } from './BaseIcon';

export const GitPOAP = forwardRef(
  (props: SVGAttributes<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="17"
      fill="none"
      viewBox="0 0 15 17"
      ref={ref}
      {...props}
    >
      <path
        fill="#838495"
        fillRule="evenodd"
        d="M12.383 11.144l1.691 3.092c.176.291 0 .496-.408.496l-1.488.058c-.32 0-.73.292-.846.554l-.788 1.46a.314.314 0 01-.583 0s-1.05-1.926-1.692-3.18c.166-.048.293-.115.397-.17l.07-.035 3.646-2.275zM.539 14.236l1.692-3.092 3.617 2.275c.054.022.104.047.156.074.089.046.182.094.31.13a173.077 173.077 0 01-1.691 3.18.315.315 0 01-.584 0l-.787-1.459c-.117-.291-.525-.554-.847-.554l-1.487-.058c-.438 0-.496-.234-.38-.496zM13.345 8.43c0 .817-.496 1.663-1.225 2.072l-3.588 1.984a2.81 2.81 0 01-1.226.292c-.408 0-.846-.059-1.225-.292l-3.588-2.013c-.73-.408-1.225-1.254-1.225-2.071V4.376c0-.817.496-1.663 1.225-2.071L6.081.29C6.43.116 6.869 0 7.306 0c.409 0 .788.058 1.226.291l3.588 2.013c.787.41 1.225 1.196 1.225 2.071V8.43zm-6.943 2.393c.291.175.583.204.904.204.32 0 .641-.059.904-.204l2.597-1.459c.554-.32.904-.904.904-1.517V4.93c0-.671-.321-1.225-.904-1.517L8.21 1.954c-.32-.175-.583-.204-.904-.204-.321 0-.642.088-.904.204L3.805 3.413c-.554.32-.904.904-.904 1.517v2.917c0 .613.379 1.226.904 1.517l2.597 1.459zm-.513-5.694a.365.365 0 00-.626-.249L4.214 5.96a.365.365 0 00-.003.504l1.05 1.109a.365.365 0 00.528-.502l-.808-.854.805-.829a.365.365 0 00.103-.259zm3.052-.331a.364.364 0 00-.118.594l.825.825-.828.85a.365.365 0 10.522.51l1.079-1.109a.365.365 0 00-.003-.512l-1.08-1.08a.364.364 0 00-.397-.078zm-.77.047a.365.365 0 00-.12-.078h.001a.364.364 0 00-.475.201l-.933 2.305a.364.364 0 10.676.274l.933-2.305a.365.365 0 00-.082-.397z"
        clipRule="evenodd"
      ></path>
    </Icon>
  ),
);
